export function scaleToCover(obj, width, height) {
	// scale the given object to fit cover the whole width/height
	const dWidth = width - obj.width;
	const dHeight = height - obj.height;
	const scale = dWidth >= dHeight ? width / obj.width : height / obj.height;
	obj.scale = new PIXI.Point(scale, scale);

	return scale;
}

export function scaleToFit(obj, width, height) {
	// scale the given object to fit inside the width/height
	const rWidth = width / obj.width;
	const rHeight = height / obj.height;
	const scale = Math.min(rWidth, rHeight);
	obj.scale = new PIXI.Point(scale, scale);

	return scale;
}
